/* eslint-disable */
import listing from "@/apollo/menus/listing.gql";
import create from "@/apollo/menus/create.gql";
import menu_by_id from "@/apollo/menus/menu_by_id.gql";

export const state = () => ({
  list: [],
  loading: false,
  creating: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 07 Jul 2023 | 01:52PM
   * @param {*} state
   * @param {*} value
   */
  setMenus(state, value) {
    state.list = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 07 Jul 2023 | 01:51PM
   * @param {*} state
   * @param {*} value
   */
  setLoading(state, value) {
    state.loading = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 08 Jul 2023 | 01:45PM
   * @param {*} state
   * @param {*} value
   */
  setCreating(state, value) {
    state.creating = value;
  }
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 07 Jul 2023 | 03:27PM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchListing({ commit }) {
    commit("setLoading", true);
    commit("setMenus", []);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing })
        .then(({ data }) => {
          commit("setMenus", data.fetch_menus);
          resolve(data.fetch_menus);
          commit("setLoading", false);
        })
        .catch((err) => {
          commit("setLoading", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 08 Jul 2023 | 01:15PM
   * @param {*} { commit }
   * @param {*} payload
   * @returns {*}
   */
  createMenu({ commit }, payload) {
    commit("setCreating", true);
    return new Promise((resolve, reject) => {
      this.$apolloClient
        .mutate({ mutation: create, variables: { payload } })
        .then(({ data }) => {
          commit("setCreating", false);
          resolve(data.create_menu);
        })
        .catch((err) => {
          reject(err);
          this.$graphError(err);
          commit("setCreating", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 08 Jul 2023 | 02:45PM
   * @param {*} __
   * @param {*} _id
   * @returns {*}
   */
  fetchMenuById(__, _id) {
    return new Promise((resolve) => {
      this.$apolloClient
        .query({
          query: menu_by_id,
          variables: { _id }
        })
        .then(({ data }) => {
          resolve(data.fetch_menu_by_id);
        })
        .catch(() => {});
    });
  }
};

export const getters = {
  list: (state) => state.list,
  loading: (state) => state.loading,
  creating: (state) => state.creating
};
